const sourceDataFilter = (dataSet, comparator) => {
    const filteredDataSet = dataSet.filter((datum) => {
        return comparator(datum);
    })

    return filteredDataSet;
}

export default sourceDataFilter;